// RevenueCat API Service
// Calls go through the getRevenuecatCustomer / grantNorppaPlus Cloud Functions, which hold the
// secret API key (REVENUECAT_API_KEY secret) and check that the caller is an admin.

import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';

export async function getCustomerInfo(appUserId) {
  try {
    const fn = httpsCallable(functions, 'getRevenuecatCustomer');
    const result = await fn({ appUserId });
    return result.data; // null if the customer doesn't exist in RevenueCat yet
  } catch (error) {
    console.error('Error fetching customer info from RevenueCat:', error);
    throw error;
  }
}

export async function grantNorppaPlusEntitlement(appUserId, durationDays = 30) {
  try {
    const fn = httpsCallable(functions, 'grantNorppaPlus');
    const result = await fn({ appUserId, durationDays });
    return result.data;
  } catch (error) {
    console.error('Error granting entitlement:', error);
    throw error;
  }
}

export function parseSubscriptionStatus(subscriber) {
  if (!subscriber) {
    return {
      status: 'No Subscription',
      active: false,
      entitlements: [],
    };
  }

  const entitlements = subscriber.entitlements || {};
  const subscriptions = subscriber.subscriptions || {};
  const norppaPlusEntitlement = entitlements['Norppa Plus'];

  let status = 'No Subscription';
  let active = false;
  let expirationDate = null;
  let willRenew = false;

  if (norppaPlusEntitlement) {
    const expiresDate = norppaPlusEntitlement.expires_date;
    active = true;

    if (expiresDate) {
      expirationDate = new Date(expiresDate);
      const now = new Date();

      if (expirationDate > now) {
        // Check if it's from a promotional grant
        const productIdentifier = norppaPlusEntitlement.product_identifier;
        if (productIdentifier === 'rc_promo') {
          status = 'Promotional';
        } else {
          // Check if it's a trial or active subscription
          const subscription = Object.values(subscriptions).find(sub =>
            sub.product_identifier === productIdentifier
          );

          if (subscription) {
            willRenew = subscription.unsubscribe_detected_at === null;

            if (subscription.billing_issues_detected_at) {
              status = 'Billing Issue';
            } else if (subscription.is_sandbox) {
              status = 'Sandbox';
            } else if (willRenew) {
              status = 'Active Subscription';
            } else {
              status = 'Cancelled (expires ' + expirationDate.toLocaleDateString() + ')';
            }
          } else {
            status = 'Active';
          }
        }
      } else {
        status = 'Expired';
        active = false;
      }
    } else {
      status = 'Lifetime';
    }
  }

  return {
    status,
    active,
    expirationDate,
    willRenew,
    entitlements: Object.keys(entitlements),
    subscriber,
  };
}
